import { api, getAllPages } from "./client";
import type {
  WidgetTemplate,
  CreateWidgetTemplateRequest,
  UpdateWidgetTemplateRequest,
} from "@/types/widget";

export const getTemplates = () =>
  getAllPages<WidgetTemplate>("/v1/templates");

export const getTemplate = (id: string) =>
  api.get<WidgetTemplate>(`/v1/templates/${id}`);

export const createWidgetTemplate = (
  data: CreateWidgetTemplateRequest,
  options?: { serviceId?: string }
) =>
  api.post<{ id: string }>("/v1/templates", data, {
    serviceId: options?.serviceId,
  });

export const updateWidgetTemplate = (
  id: string,
  data: UpdateWidgetTemplateRequest
) => api.patch<{ id: string }>(`/v1/templates/${id}`, data);

// NOTE: No UI deletes a template yet: a widget's template is created and
// updated alongside it, so deleting a widget currently leaves its template
// behind. This is the endpoint that flow will need.
export const deleteWidgetTemplate = (id: string) =>
  api.delete<{ id: string }>(`/v1/templates/${id}`);
